import axios from 'axios';

const exportUser = () => axios.get('users/export');

export { exportUser };
